import React from 'react';

import { Flex } from "@chakra-ui/react";
import { grouper } from "../../helpers/grouper"

export const LeftPanel  = ({ children }) => { return (<>{ children }</>) }
export const RightPanel = ({ children }) => { return (<>{ children }</>) }

export const TwoColumns = ({ children }) => {
  const groups = grouper(children);
  const colAttrs = { 'flexDir': 'column', 'gap': 10 };
  return (
    <Flex id="columns" gap="2%" flexWrap='wrap'>
      <Flex id={'left-column'}  {...colAttrs} w={{'md': '100%', 'lg': '58%' ,'xl': '70%'}}>
        { groups[LeftPanel.name] }
      </Flex>
      <Flex id={'right-column'} {...colAttrs} w={{'md': '100%', 'lg': '40%', 'xl': '28%'}}>
        { groups[RightPanel.name] }
      </Flex>
    </Flex>
  )
}

